<template>
  <v-container>
    <div v-if="subscriptionSurvey">
      <div class="pointer subtitle-1 grey-navy--text font-weight-bold text-decoration-none" @click="back">
        <v-icon small class="pb-1"> keyboard_backspace </v-icon> Back
      </div>
      <h1 v-if="subscriptionSurvey.title" v-html="subscriptionSurvey.title" />
      <h1 v-else>
        {{ capitalize(subscriptionSurvey.survey.surveyType) }}
      </h1>
      <h3>
        submitted by {{ subscriptionSurvey.subscription.user.firstName }}
        {{ subscriptionSurvey.subscription.user.lastName }} on {{ subscriptionSurvey.submittedDate }}
      </h3>
      <h3 v-if="subscriptionSurvey.subscription.coach">
        coached by {{ subscriptionSurvey.subscription.coach.firstName }}
        {{ subscriptionSurvey.subscription.coach.lastName }}
      </h3>

      <div v-if="results.length > 0" class="mt-6">
        <div v-for="result in results" :key="result.id">
          <h3>{{ result.question }}</h3>
          <p>{{ result.answer }}</p>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { SUBSCRIPTION_SURVEY_QUERY } from "@/graphql/queries/survey";
import { capitalize } from "@/lib/string";

export default {
  name: "SurveyView",
  props: {
    subscriptionSurveyId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      results: [],
    };
  },
  methods: {
    capitalize(value) {
      value = value.replace("A_", "");
      return capitalize(value);
    },
    back() {
      this.$router.go(-1);
    },
  },
  apollo: {
    subscriptionSurvey: {
      query: SUBSCRIPTION_SURVEY_QUERY,
      variables() {
        return {
          subscriptionSurveyId: this.subscriptionSurveyId,
        };
      },
      result(response) {
        if (response.data) {
          this.results = response.data.subscriptionSurvey.answerSet.map((item) => {
            let answer;
            if (item.answer) {
              answer = item.answer;
            } else {
              answer = item.option?.title;
            }
            return {
              id: item.id,
              question: item.surveyQuestion?.question?.title,
              answer: answer,
            };
          });
        }
      },
    },
  },
};
</script>
